import * as yup from 'yup';

export const campaignFormSchema = yup.object().shape({
	campaignName: yup
		.string()
		.matches(/^(?=.*[A-Za-z0-9])[A-Za-z0-9 _]*$/, {
			message:
				'Please enter Alphanumeric values only. Ensure that special characters are not present in the string.',
		})
		.required('Enter Campaign Name'),
	clientId: yup.string().required('Select Client'),
});
